import { TsuLoading } from '@/common/components';
import { AppLayout } from '@/layouts/AppLayout';
import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { IPunchoutWaivenet, IPunchoutWaivenetVars } from '../../PunchoutInterface';

const WAIVENET_PUNCHOUT_REPORT_MUTATION = gql`
  mutation ($destination: String!, $returnURL: String!) {
    punchoutWaivenetReport(input: { destination: $destination, returnURL: $returnURL }) {
      success
      link
    }
  }
`;

export function WaivenetReport() {
  const [punchoutWaivenetReportMutation, { data, loading }] = useMutation<
    IPunchoutWaivenet,
    IPunchoutWaivenetVars
  >(WAIVENET_PUNCHOUT_REPORT_MUTATION, {
    variables: { destination: 'wnreports', returnURL: 'https://test.com.au' },
  });

  useEffect(() => {
    punchoutWaivenetReportMutation();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      console.log('[WaivenetReport] Got MessageEvent:', event);
      console.log('got here?');
      if (event.origin === 'https://staging.waivenet.com.au') {
        try {
          console.log('[WaivenetReport] Event data:', event.data);
        } catch (err) {
          console.error(`[WaivenetReport] Error parsing message: ${event.data.toString()}`);
        }
      }
    };
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <AppLayout title="Waivenet Reports">
      <TsuLoading loading={loading}>
        <iframe
          id="punchout"
          // @ts-ignore
          src={data?.punchoutWaivenetReport.link}
          style={{ width: '100%' }}
          height={1080}
        ></iframe>
      </TsuLoading>
    </AppLayout>
  );
}